import React, { useEffect } from 'react'
import { useGetPermitByIdQuery } from '../../../../services/EndPointsApis';

const PermitAcceptSaleWizard = ({ formikPermitSale, storeProjectId }: any) => {

    //get Permit Api
    const { data: getPermitSaleData } = useGetPermitByIdQuery({ Id: storeProjectId })

    return (

        <div className='row'>
            <div className='col-md-12'>
                <h5 className='mb-2 mt-2'>Permit Info</h5>
                <div className="d-flex gap-5">
                    {getPermitSaleData?.result?.projPermitResult.map((permit: any, index: number) => (
                        <div className="d-flex align-items-center" key={permit.surveyMasterId}>
                            <label className="checkboxs mt-2 mb-4">
                                <input
                                    type="checkbox"
                                    name={`projPermitResult[${index}].surveyResultOriginal`}
                                    checked={formikPermitSale.values?.projPermitResult[index]?.surveyResultOriginal === "1"}
                                    onChange={(e) => {
                                        formikPermitSale.setFieldValue(
                                            `projPermitResult[${index}].surveyResultOriginal`,
                                            e.target.checked ? "1" : "0"
                                        );
                                        formikPermitSale.setFieldValue(
                                            `projPermitResult[${index}].surveyMasterId`,
                                            permit?.surveyMasterId
                                        );
                                        formikPermitSale.setFieldValue(
                                            `projPermitResult[${index}].fieldType`,
                                            permit?.fieldType
                                        );
                                        formikPermitSale.setFieldValue(
                                            `projPermitResult[${index}].sectionId`,
                                            permit?.sectionId
                                        );
                                        formikPermitSale.setFieldValue(
                                            `projPermitResult[${index}].subSectionId`,
                                            permit?.subSectionId
                                        );
                                        formikPermitSale.setFieldValue(
                                            `projPermitResult[${index}].name`,
                                            permit?.name
                                        );
                                    }}
                                />
                                <span className="checkmarks" />
                            </label>
                            <span>{permit.name}</span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default PermitAcceptSaleWizard